// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.remind.list/calendar.remind.item/calendar.remind.item.scss
// module id = 4926
// module chunks = 50